export function capitalize(string) {
    if (string && string.length >= 1) {
        let capitalizedString = string.charAt(0).toUpperCase()
        if (string.length > 1) {
            capitalizedString += string.slice(1)
        }
        return capitalizedString
    }
    return null
}